module.exports = __webpack_public_path__ + "static/media/screen_home.426c5f2c.png";